module.exports = __webpack_public_path__ + "img/dog-walk-min.c397585f.jpg";